import IconCloudDisconnect from '@apollo/icons/default/IconCloudDisconnect.svg';
import IconSecurity from '@apollo/icons/default/IconSecurity.svg';
import IconSuccess from '@apollo/icons/default/IconSuccess.svg';
import IconWarning from '@apollo/icons/default/IconWarning.svg';
import { StatusBadgeProps } from '@apollo/orbit';
import { ElementType } from 'react';

import { UPDATE_SEVERITY } from './packageMetadata/packageMetadata';

interface SeverityComponentConfig {
  Icon: ElementType;
  color?: StatusBadgeProps['colorScheme'];
  text: string;
}

export const severityComponents: Record<
  UPDATE_SEVERITY,
  SeverityComponentConfig
> = {
  [UPDATE_SEVERITY.UpToDate]: {
    Icon: IconSuccess,
    color: 'green',
    text: 'Up-to-date',
  },
  [UPDATE_SEVERITY.Unknown]: {
    Icon: IconCloudDisconnect,
    text: 'Unknown',
  },
  [UPDATE_SEVERITY.Patch]: {
    Icon: IconWarning,
    color: 'yellow',
    text: 'Patch Version',
  },
  [UPDATE_SEVERITY.Minor]: {
    Icon: IconWarning,
    color: 'yellow',
    text: 'Minor Version',
  },
  [UPDATE_SEVERITY.Major]: {
    Icon: IconWarning,
    color: 'yellow',
    text: 'Major Version',
  },
  [UPDATE_SEVERITY.Security]: {
    Icon: IconSecurity,
    color: 'red',
    text: 'Security',
  },
};
